import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/AuthContext";
import { PlatformLayout, BonsteloLogo } from "./Layout";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Loader2 } from "lucide-react";

function formatErr(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
}

export const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <PlatformLayout subtitle="Für Betriebe & Team">
      <div className="max-w-sm mx-auto pt-6 animate-float-up">
        <div className="text-center mb-6">
          <div className="flex justify-center mb-3"><BonsteloLogo className="h-11" /></div>
          <h1 className="font-display font-extrabold text-3xl text-[var(--bs-ink)]">Anmelden</h1>
          <p className="text-slate-500 text-sm font-medium mt-1">Willkommen zurück bei Bonstelo.</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-3xl ring-1 ring-slate-100 shadow-soft p-6 space-y-4">
          <div className="space-y-1.5">
            <label className="text-xs font-bold text-slate-500">E-Mail</label>
            <Input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@email.de" className="h-12 rounded-xl" required />
          </div>
          <div className="space-y-1.5">
            <label className="text-xs font-bold text-slate-500">Passwort</label>
            <Input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="h-12 rounded-xl" required />
          </div>
          {error && <p data-testid="login-error" className="text-sm font-semibold text-rose-600 bg-rose-50 rounded-xl px-3 py-2">{error}</p>}
          <Button data-testid="login-submit-button" type="submit" disabled={busy}
            className="w-full h-13 py-3.5 rounded-2xl bg-[var(--bs-teal)] hover:bg-[var(--bs-teal-hover)] font-display font-bold text-base press disabled:opacity-60">
            {busy ? <><Loader2 className="mr-1 h-5 w-5 animate-spin" /> Bitte warten…</> : "Anmelden"}
          </Button>
        </form>
        <p className="text-center text-sm text-slate-500 mt-5">
          Noch kein Betrieb?{" "}
          <Link data-testid="go-register-link" to="/register" className="font-bold text-[var(--bs-teal)]">Jetzt registrieren</Link>
        </p>
      </div>
    </PlatformLayout>
  );
};
